import React from 'react'

const ResendOTPMessage = ({ setResendOtp }) => {
    return (
        <div className="login--content">
            <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.6 21.5L5.7 18.3L2.1 17.5L2.45 13.8L0 11L2.45 8.2L2.1 4.5L5.7 3.7L7.6 0.5L11 1.95L14.4 0.5L16.3 3.7L19.9 4.5L19.55 8.2L22 11L19.55 13.8L19.9 17.5L16.3 18.3L14.4 21.5L11 20.05L7.6 21.5ZM9.95 14.55L15.6 8.9L14.2 7.45L9.95 11.7L7.8 9.6L6.4 11L9.95 14.55Z" fill="#1EB24B" />
                    </svg>
                </div>
                <div className='successMessage'>
                    <p>
                        We have emailed and SMS-ed your One Day Password (ODP).                    </p>
                    <p>
                        Please access your email or SMS to find the same.
                    </p>
                </div>
            </div>
            <div
                className="submit--btn"
                onClick={() => setResendOtp(false)}
            >
                GO BACK
            </div>
        </div>
    )
}

export default ResendOTPMessage